module.exports = __webpack_public_path__ + "static/media/test1 (24).9c6fc508.jpg";